
# More Diversity

As I went about my business today and was in the Twitter-verse and various YouTube rabbit holes, I realized very blatantly that there is a lack of diversity in the materials I found. If anyone has any recommendations for women in philosophy, mathematices and computer science I would very much appreciate the recommendations.

# "Tools of Titans"

[David Perell on Twitter: "I wish every productive person wrote a book-length guide to how they live, work, and think. Can you imagine what we’d learn?" / Twitter](https://twitter.com/david_perell/status/1287772831409778688)

- The closest word I can find to describe it is “Praxis.” The word originates in Ancient Greek to describe how a process can be embodied.
It’s a practical explanation of how the brain, body, and heart influence each other.
- books
  - Getting Things Done by David Allen
  - Atomic Habits by James Clear
  - 7 Habits by Stephen Covey
- See also “techne” as in Spenglers Man and Technics or Aristotle.
- Partnerships, policy, perseverance

[Michael Dean on Twitter: "@david_perell A compilation for each category (live, work, think) would highlight how many ways you can approach the same thing. Would be neat if it went even more granular. "Here are 100 different ways productive people handle a task list."" / Twitter](https://twitter.com/MichaelDean09/status/1287774009426415617)

> A compilation for each category (live, work, think) would highlight how many ways you can approach the same thing.
> 
> Would be neat if it went even more granular.
> 
> "Here are 100 different ways productive people handle a task list."

[Jeremy Giffon on Twitter: "You set the price, I’ll set the terms A mindset shift I learned from @awilkinson in investing but it really applies to everything. Similar to Ferriss’ “what if this were easy” or Thiel’s “what if you had to achieve your 10yr plan in 6 mths” Most things don’t have to be hard!" / Twitter](https://twitter.com/jeremygiffon/status/1287775252991401989)

> You set the price, I’ll set the terms
> 
> A mindset shift I learned from @awilkinson in investing but it really applies to everything. 
> 
> Similar to Ferriss’ “what if this were easy” or Thiel’s “what if you had to achieve your 10yr plan in 6 mths”
> 
> Most things don’t have to be hard!

# [Peterson and Weinstein Debate the Economy - YouTube](https://www.youtube.com/watch?v=NNEN9noyp5c&feature=youtu.be)

- 1970 phase change
  - GDP and median male income
  - both going up together and then one flat-lines and one keeps going
  - 2+ generations of experts lying about what happened
- Derek De Sola Price
  - Price's law
  - PhDs, journals, funding
  - predicted PhDs per child breaks apart
- 1945-1970 growth regime
  - embedded growth obligation
  - pathological...
- "lie to keep institutions afloat"
  - tell them a story that if you work hard you will become a partner
  - professor -> 20 students -> become professor -> 20 students
  - "hidden pyramid scheme"
- very rich family to live out the days in style we've become accustomed
  - off shore
  - mergers and acquisitions
  - self regulation of markets
- "transfer to service and intellectual economy vs manufacturing"
- growth is scientifically led?
  - growth laws that can't go on forever
- Venice first 4 days
  - 52 years didn't prepare me
  - 4 days it removes the level of magic
  - hedonic numbing
  - genie coefficients (period of inequality)
- humans focused on things like status  
- high standard of living vs incremental life improvement
- ability to make a 30 a year plan...
  - idea of getting to retirement, etc
- predictability is gone
- jobs won't be means of redistribution of wealth
- anthropic capitalism...
- massive systemic changes... (what they are and what they would do)
  - control virtue that you pour into your life
  - non-virtuous means that someone earning more you are worse off
- advanced capitalism leads to a rat race...?
  
> lack of inculcation of morality...?

# Evening Constitutional

- walk with the parents
- I love recording these conversations
- Google Drive Voice Record Pro
- Meyers Briggs
  - ENFJ-T
  - Turbulent Protagonist
  - Diplomat
  - Social Engagement
